/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

export const getPublicAchievementEarlyRequestRpc = {
  serviceName: 'com.hubspot.credentials.rpc.AchievementPublicRpc',
  rpcName: 'getPublicAchievement',
  auth: 'external',
  fingerprint: 'IlAHR304DaWB0Giq6LwKZZEAXm2HbnMQ',
  earlyRequest: true,
  na1Only: false,
  isStreaming: false
};